import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #4f4f4f;
  padding-top: 30px;
  margin-top: 56px;
  padding-bottom: 100px;

  ${mediaQuery.desktop`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
  padding-top: 30px;
  margin-top: 56px;
  color: #4f4f4f;
  padding-bottom: 100px;
  `}
`;

export const Box = styled.div`
  display: flex;
  ${'' /* justify-content: space-between; */}
  align-content: center;
  align-items: center;
  width: auto;

  ${mediaQuery.desktop`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  `}

  .page-list {
    display: flex;
    white-space: no-wrap;
    margin-right: 24px;
  }

  .page {
    margin-left: 24px;
  }

  .non-active {
    width: auto;
    height: 38px;
    border-radius: 5px;
    display: flex;
    place-items: center;
    margin-left: 10px;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor: pointer;
    font-size: 20px;
    font-weight: 400;
  }

  ${mediaQuery.desktop`
  .non-active {
    width: 39px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    margin-left: 5px;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor:pointer;
  }
  `}

  .active-text {
    color: #549a9a;
  }

  .active {
    background: #549a9a;
    color: #fff;
    width: 40px;
    height: 40px;
    display: flex;
    border: 1px solid #acd1d1;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor: pointer;
    font-size: 20px;
    font-weight: 400;
  }

  ${mediaQuery.desktop`
  .active {
    background: #549a9a;
    color: #fff;
    width: 40px;
    height: 40px;
    border: 1px solid #ACD1D1;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor:pointer;
    font-size: 20px;
    font-weight: 400;
  }
  `}
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  outline: none;
  border: 1px solid #acd1d1;

  ${mediaQuery.desktop`
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  gap: 12px;
  outline: none;
  border: 1px solid #ACD1D1;
  color: #BDBDBD;
  `}

  .btn {
    font-size: 20px;
    color: #171718;
    font-weight: 700;
    -webkit-text-stroke: 1px #acd1d1;
    text-stroke: 1px #acd1d1;
  }
`;
